/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Gym_OneInputs */

const en_features_gym_one = /** @type {(inputs: Features_Gym_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Northside Gym`)
};

const pl_features_gym_one = /** @type {(inputs: Features_Gym_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siłownia Północ`)
};

/**
* | output |
* | --- |
* | "Northside Gym" |
*
* @param {Features_Gym_OneInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_gym_one = /** @type {((inputs?: Features_Gym_OneInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Gym_OneInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_gym_one(inputs)
	return en_features_gym_one(inputs)
});